import { render } from "./OnBoardingDriver.vue?vue&type=template&id=5e60eae9&scoped=true"
import script from "./OnBoardingDriver.vue?vue&type=script&lang=js"
export * from "./OnBoardingDriver.vue?vue&type=script&lang=js"

import "./OnBoardingDriver.vue?vue&type=style&index=0&id=5e60eae9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e60eae9"]])

export default __exports__